import type { BannerSpec } from '@invideoio/web-shared/components/WebinarBanner/banner-specs';
import React from 'react';

// Carries the CMS-driven banner slides from RootApp down to the banner component
// without prop drilling. `null` means "no CMS data" — consumers fall back to the
// shared WebinarBanner's own hardcoded slides.
export const AnnouncementBannerContext = React.createContext<
  BannerSpec[] | null
>(null);

export const useAnnouncementBanners = () =>
  React.useContext(AnnouncementBannerContext);
